import { render, staticRenderFns } from "./LmCustomerCodificatorBuilderListbuilder.vue?vue&type=template&id=133d90f8"
import script from "./LmCustomerCodificatorBuilderListbuilder.vue?vue&type=script&lang=js"
export * from "./LmCustomerCodificatorBuilderListbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports